module.exports = __webpack_public_path__ + "img/hdsmrs.a73df969.png";